module.exports = __webpack_public_path__ + "img/logo-garde.a3578c3e.png";